var site = site || {};

(function ($) {
  Drupal.behaviors.productAutoreplenishV1 = {
    attach: function (context, settings) {
      var self = this;
      var $autoreplenishSelect = $('.autoreplenish_select', context);
      var $addToBag = $('.product-full .btn-add-to-bag', context);

      $autoreplenishSelect.on('change', function () {
        var autoreplenishTime = $(this).val();
        var skuData = self.getSku(parseInt($addToBag.data('skubaseid')));

        $addToBag.data('freq', autoreplenishTime);
        site.quickshop.initAddToBag($addToBag, skuData.SKU_BASE_ID, skuData);
      });
    },
    getSku: function (skuID) {
      var skus = page_data['catalog-spp']['products'][0].skus;

      for (var i in skus) {
        if (skuID === skus[i].SKU_BASE_ID) {
          return skus[i];
        }
      }
    }
  };
})(jQuery);
